import { render } from "./languagePage.vue?vue&type=template&id=48a5356a"
import script from "./languagePage.vue?vue&type=script&lang=js"
export * from "./languagePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__